import { Currency, Languages } from '@dark-portal/backend-planora';
import i18n from 'i18next';

export function getDefaultCurrencyBasedOnLang(): Currency {
  if (i18n.language === Languages.PL) {
    return Currency.PLN;
  }

  return Currency.EUR;
}
